<template>
  <div class="repeat-scheduled-info">
    <div class="row">
      <label class="col-sm-3 control-label pt-10"> Pickup Time* </label>
      <time-picker
        v-model="data.pickupTime"
        class="col-sm-8"
        required
        clearable
        format="hh:mm a"
        @blur="$emit('change-pickup-time')"
      >
        <template #comment>
          <span
            v-if="isShowTimeWarningMessage"
            class="help-block warning-message"
          >
            Please inform the rider that it may be hard to get a driver at this scheduled time.
          </span>
        </template>
      </time-picker>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Repeat </label>
      <div class="col-sm-8">
        <dropdown-list
          v-model="data.repeatEveryXWeek"
          value-key="id"
          :options="repeatWeeks"
        />
      </div>
    </div>

    <div class="row repeat-on">
      <label class="col-sm-3 control-label"> Repeat on </label>
      <div class="col-sm-8">
        <div class="row mb-0">
          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day0">
              Sunday
            </el-checkbox>
          </div>

          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day1">
              Monday
            </el-checkbox>
          </div>

          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day2">
              Tuesday
            </el-checkbox>
          </div>

          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day3">
              Wednesday
            </el-checkbox>
          </div>

          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day4">
              Thursday
            </el-checkbox>
          </div>

          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day5">
              Friday
            </el-checkbox>
          </div>

          <div class="col-6 checkbox-container">
            <el-checkbox v-model="data.day6">
              Saturday
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> Starts on* </label>
      <div class="col-sm-3">
        <date-picker
          v-model="data.pickupDate"
          required
          :disabled-date="disabledDate"
          :disabled="!!data.id"
        />
      </div>
    </div>

    <div class="row">
      <label class="col-sm-3 control-label"> Ends on </label>
      <div class="col-sm-8">
        <div class="pb-10">
          <el-radio
            v-model="data.endOnType"
            label="never"
          >
            Never
          </el-radio>
        </div>

        <div class="pb-10">
          <el-radio
            v-model="data.endOnType"
            label="after"
            class="flex-radio"
          >
            After
            <input
              v-model="data.endAfterXTimes"
              type="number"
              class="form-control occurences-num"
              :min="data.endOnType === 'after' ? 1 : 0"
              autocomplete="nope"
            >
            occurences
          </el-radio>
        </div>

        <div class="pb-10">
          <el-radio
            v-model="data.endOnType"
            label="on"
            class="flex-radio"
          >
            On
            <date-picker
              v-model="data.endOn"
              class="pl-10 mobile-pl-10"
              :required="isEndOnRequired"
              :disabled-date="disabledDate"
            />
          </el-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { repeatWeeks } from '@/constants/ride';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },

  isShowTimeWarningMessage: {
    type: Boolean,
    default: false,
  },

  disabledDate: {
    type: Function,
    default: () => null,
  },
});

defineEmits(['change-pickup-time']);

const isEndOnRequired = computed(() => props.data.endOnType === 'on' && props.data.rideMultiple);
</script>

<style lang="scss">
.repeat-scheduled-info {
  .flex-radio {
    .el-radio__label {
      display: flex;
      align-items: center;
      width: fit-content;

      span.form-check-sign::before,
      span.form-check-sign::after {
        top: 5px;
      }
    }
  }

  .occurences-num {
    width: 80px;
    margin: 0 5px;
    padding: 0 10px;
    @media (max-width: 576px) {
      margin: 0 10px;
    }
  }
}
</style>
